'use client';
import { format } from 'date-fns';
import Link from 'next/link';
import React from 'react';
import { BlogCard } from '@/components/blog/blog-card';
import { truncate } from '@/lib/utils';
import { Article } from '@/types/types';

interface BlogPostRowsProps {
	articles: Article[];
	locale: string;
}

export function BlogPostRows({ articles, locale }: BlogPostRowsProps) {
	return (
		<>
			<h2 className="mb-8 text-center text-2xl font-bold text-neutral-900 sm:text-3xl md:mb-12 md:text-4xl">
				Latest Articles
			</h2>
			<div className="grid w-full gap-8 md:grid-cols-2 lg:grid-cols-3">
				{articles.map((article, idx) => (
					<BlogCard
						key={article.slug}
						article={article}
						locale={locale}
						priority={idx < 3}
					/>
				))}
			</div>
		</>
	);
}

export const BlogPostRow = ({ article }: { article: Article }) => {
	return (
		<Link
			href={`/blog/${article.slug}`}
			key={`${article.slug}`}
			className="group flex flex-col items-start justify-between py-4 md:flex-row md:items-center">
			<div>
				<p className="text-lg font-medium text-neutral-900 transition duration-200">
					{article.title}
				</p>
				<p className="mt-2 max-w-xl text-sm text-neutral-600 transition duration-200">
					{truncate(article.description || '', 80)}
				</p>

				<div className="my-4 flex items-center gap-2">
					<p className="max-w-xl text-sm text-neutral-500 transition duration-200">
						{format(new Date(article.createdAt), 'MMMM dd, yyyy')}
					</p>
					<div className="h-1 w-1 rounded-full bg-neutral-300"></div>
					<div className="flex flex-wrap gap-4">
						{article.categories?.map((category, idx) => (
							<p
								key={`category-${idx}`}
								className="rounded-full bg-neutral-100 px-2 py-1 text-xs font-bold capitalize text-neutral-700">
								{category.name}
							</p>
						))}
					</div>
				</div>
			</div>
			{/* <Image
        src={blog.authorAvatar}
        alt={blog.author}
        width={40}
        height={40}
        className="rounded-full md:h-10 md:w-10 h-6 w-6 mt-4 md:mt-0 object-cover"
      /> */}
		</Link>
	);
};
